import type { RemoveCustomerNoteResponse } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../../../../services/api';
import { queryKeys } from '../../../../../../services/query-key/query-keys';

type RemoveCustomerNoteVariables = {
  noteId: string;
  customerId: string;
};

export function useRemoveCustomerNote(
  options?: UseMutationOptions<RemoveCustomerNoteResponse, unknown, RemoveCustomerNoteVariables>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ({ noteId }) => {
      const api = getPrivateApi();

      return api.removeCustomerNote({ noteId });
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(queryKeys.customerNotes(variables.customerId));

        await options?.onSuccess?.(data, variables, context);
      },
    },
  );
}
